import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import PaginatedTable from "../../Common/PaginatedTable";
import { displayDateOnly } from "../../../Utils";
import { Job } from "../../../Models/Job";

export default function ClientJobListTable({ data }: { data: Job[] }) {
  const columnHelper = createColumnHelper<Job>();

  const columns = [
    columnHelper.accessor((row) => row.client?.id, {
      id: "clientId",
      header: "Client",
      cell: (info) => <span>{info.row.original.client?.name}</span>,
      sortingFn: "alphanumeric",
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor((row) => row.clientLocation?.id, {
      id: "clientLocationId",
      header: "Location",
      cell: (info) => (
        <span>
          {info.row.original.clientLocation?.address}{" "}
          {info.row.original.clientLocation?.city}{" "}
          {info.row.original.clientLocation?.state
            ? info.row.original.clientLocation?.state.name
            : ""}
        </span>
      ),
      sortingFn: "alphanumeric",
      footer: (info) => info.column.id,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.startDate, {
      id: "startDate",
      header: "Start",
      cell: (info) => (
        <i>
          {displayDateOnly(info.getValue() ? new Date(info.getValue()!) : null)}
        </i>
      ),
      sortingFn: "alphanumeric",
      footer: (info) => info.column.id,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.endDate, {
      id: "endDate",
      header: "End",
      cell: (info) => (
        <i>
          {displayDateOnly(info.getValue() ? new Date(info.getValue()!) : null)}
        </i>
      ),
      sortingFn: "alphanumeric",
      footer: (info) => info.column.id,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => null, {
      id: "jobItems",
      header: "Delivery Items",
      cell: (info) => <i>{info.row.original.jobItems?.length}</i>,
      sortingFn: "alphanumeric",
      footer: (info) => info.column.id,
      enableColumnFilter: false,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className="w-full mx-auto overflow-x-auto">
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode="onChange"
          showFilters={true}
        />
      </div>
    </>
  );
}
